<template>
  <div class="scene-info right_cont">
    <el-breadcrumb
      v-if="!embedInRecycle"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">
        {{ $t("breadcrumb.home") }}
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'control' }">
        {{ $t("breadcrumb.control") }}
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'control' }">
        {{ $t("breadcrumb.scence") }}
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t("breadcrumb.scenceMsg") }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div
      class="out_bread"
    >
      <div class="scene_main">
        <!-- <img
          src="../../../../assets/img/bg/colors.png"
          alt=""
        > -->
        <vuescroll @handle-scroll="scrollEvent">
          <BaseInfo
            ref="baseInfo"
            :parameters="parameters"
          />
          <div
            class="scene_title blue_header"
          >
            <!-- 灯带场景信息 -->
            <span>{{ $t('sceneTemplate.lightingParameters') }}</span>
          </div>
          <div
            class="scene-container"
            :style="{padding: '20px 45px', border: 'solid 1px #e0e3e6', marginBottom: '24px' }"
          >
            <LightDuvControl
              v-if="optionRange && option"
              ref="LightDuvControl"
              show-duv
              show-temperature
              :option="option"
              :option-range="optionRange"
              :default-option-ache="defaultOptionAche"
              @change="onOptionChange"
            />
          </div>
          <TripList
            v-if="checkDeviceList && checkDeviceList.length !== 0"
            ref="TripList"
            :show-delete="true"
            :list="checkDeviceList"
            :shape-type="parameters.shapeType"
            :canvas-init-data="canvasInitData"
            :hiden-control="true"
            @updateList="onUpdateList"
            @onSort="onDeviceSort"
          />
          <LightColorSet
            v-if="template && device"
            ref="LightColorSet"
            :device="device"
            :template="template"
            :option="option"
            :device-list="checkDeviceList"
            :option-range="optionRange"
            :default-option-ache="defaultOptionAche"
            :col-row-option="parameters.colRowOption"
            :shadow-action="shadowAction"
            :matrix-value-ui="matrixValueUi"
            :from="parameters.from"
            @resetOption="onResetOption"
            @imgUpdate="onImgUpdate"
          />
          <!-- <LightStripSceneCanvas
            ref="LightStripSceneCanvas"
            :shape-type="parameters.shapeType"
            :from="parameters.from"
            :canvas-init-data="canvasInitData"
            :check-device-list="checkDeviceList"
            :get-first-device-id="getFirstDeviceId"
            @onDeviceActive="onDeviceActive"
            @imgUpdate="onImgUpdate"
            @canvasReady="onCanvasReady"
          /> -->
          <div
            class="scene_btnList"
          >
            <!-- 取消 -->
            <el-button
              v-if="!embedInRecycle"
              plain
              @click="handlerBack"
            >
              {{ $t('findGateway.cancle') }}
            </el-button>
            <!-- 保存 -->
            <el-button
              v-if="parameters.from !== 'recycle'"
              class="scene_save"
              plain
              :loading="isLoadingSave"
              @click="handlerSaveClick"
            >
              {{ $t('sceneCard.save') }}
            </el-button>
          </div>
        </vuescroll>
      </div>
    </div>
  </div>
</template>

<script>
import { transformPointToCXCY, transRgbToLight, rgbToHex } from '@/components/DesignCanvas/utils/common';
import vuescroll from "vuescroll";
import {
  getFillOrderFn,
} from "@/page/control-ts/scene/sceneHandle/indexFns";
import {
  Create as reqSaveScene,
  Edit as reqEditScene,
  FindScene,
  SceneRecoverDetail,
  SaveOrUpdateCustomData,
  GetCustomDataList
} from "@/axios/IScene.js";
import { alerterror, alertsuccess } from "@/assets/js/common.js";
import { mergeSceneRouteOpts } from '@/utils/imageSceneRoute';
// import LightStripSceneCanvas from './LightStripSceneCanvas';
// import DesignCanvas from "@/components/DesignCanvas";
import { 
  TEMPLATE_1, 
  TEMPLATE_2,
  TEMPLATE_3,
  TEMPLATE_4,
  TEMPLATE_5,
  TEMPLATE_6,
  TEMPLATE_7,
  TEMPLATE_8,
  TEMPLATE_9,
  TEMPLATE_10,
  TEMPLATE_11,
  TEMPLATE_12,
  TEMPLATE_13,
  TEMPLATE_14,
  TEMPLATE_15,
  TEMPLATE_16,
  TEMPLATE_17,
  TEMPLATE_18,
  TEMPLATE_19,
  TEMPLATE_20,
  TEMPLATE_21,
  TEMPLATE_22,
  TEMPLATE_23,
  TEMPLATE_24,
  TEMPLATE_29
} from './template/index';
import BaseInfo from "../components/BaseInfo.vue";
import LightColorSet from "../components/LightColorSet.vue";
import TripList from "../components/TripList";
import LightDuvControl from "../components/LightDuvControl";
import { UploadFile } from "@/axios/ICommon.js";
import { shootImg } from "@/utils/img.js";
// import DesignCanvas from "@/components/DesignCanvas";
import {
  Finduiability,
  FindActionAbilityWithStatus,
} from '@/axios/IDevice.js'

function bitwiseNotToHex(number) {
  // 确保输入是32位有符号整数
  number = number & 0xFFFFFFFF;

  // 使用位取反操作符 ~ 进行位取反
  let bitwiseNotResult = ~number;

  // 将结果转换为无符号32位整数
  let unsignedResult = bitwiseNotResult >>> 0;

  // 将结果转换为十六进制表示
  let hexResult = unsignedResult.toString(16).toUpperCase();

  return hexResult.slice(-2);
}

function transDuvValue(num) {
  if (num < 0) {
    return ('0' + (parseInt(bitwiseNotToHex(Math.abs(num)), 16) + 1).toString(16)).slice(-2);
  }

  return ('0' + Number(num).toString(16)).slice(-2);
}

function transTemperature(num) {
  return ('0' + Number(num).toString(16)).slice(-4);
}

const COLOR_TEMPERATURE_VALUE_TYPES = [
  'UIControl_ColorTemperature',
  'UIControl_ColorTemperature_SDL',
];

export default {
  components: {
    vuescroll,
    BaseInfo,
    TripList,
    // LightStripSceneCanvas,
    LightDuvControl,
    LightColorSet
  },
  props: {
    embedInRecycle: {
      type: Boolean,
      default: false
    },
    embedSceneNo: {
      type: Number,
      default: undefined
    },
    embedGpNo: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      shapeType: 0,
      curDevice: null,
      checkDeviceList: [],
      option: null,
      canvasInitData: null,
      parameters: {},
      designCanvasInstance: null, // 用于纵横能力的组件 获取颜色能力
      drawCanvasInstance: null, // 用于自定义的组件 获取颜色信息
      drawInstance: null,
      isLoadingSave: false,
      template: null,
      optionRange: null,
      defaultOptionAche: null,
      device: null,
      matrixValueUi: null,
      shadowAction: null
    };
  },
  computed: {
  },
  watch: {
   option(val) {
    console.log('watch watch watch', val);
   }
  },
  created() {
    if (this.embedInRecycle) {
      this.parameters.from = 'recycle';
      this.parameters.SceneNo = this.embedSceneNo;
      this.parameters.GpNo = this.embedGpNo;
      this.requestInfo();
      return;
    }

    const params = mergeSceneRouteOpts(this.$route);

    this.parameters.from = params.from;
    
    if (params.from === 'edit' || params.from === 'copy' || params.from === 'recycle') {
      // 初始化编辑模式查询场景
      this.requestInfo();
    } else {
      this.initRouteParams();
    }
  },

  methods: {
    /** 取第一台未删除且有 ClassSku 的设备，用于拉能力 */
    getValidAbilityDevice(deviceList = []) {
      return (deviceList || []).find(item => !item.IsDel && item.ClassSku != null) || null
    },

    async getOptionRange(device) {
      if (!device) return {};

      const { ClassSku, VDeviceId } = device || {};
      const res = await FindActionAbilityWithStatus({
        classSku: ClassSku,
        vDeviceId: VDeviceId
      });

      const uiRes = await Finduiability({
        vDeviceId: device.VDeviceId
      });

      if (!uiRes || !uiRes.Result || !uiRes.Result.UIConfigV2) return {};

      const actionList = res?.Result && res.Result.reduce((pre, next) => {
        return pre.concat(next.ActionList);
      }, []);
      const actionValuesList = actionList.reduce((pre, next) => {
        return pre.concat(next.Values);
      }, []);

      const imageScene = uiRes.Result.UIConfigV2.imageScene || {};

      if (imageScene.matrix) {
        const matrixValue = actionList.find(item => item.Code === imageScene.matrix);

        if (matrixValue && matrixValue.UI) {
          this.matrixValueUi = matrixValue.UI;
        };
      };

      if (imageScene && imageScene.shadowSwitch) {
        const shadowSwitch = actionList.find(item => item.Code === imageScene.shadowSwitch);

        if (shadowSwitch) {
          const value0 = (shadowSwitch.Values || [])[0] || {};
          const value1 = (shadowSwitch.Values || [])[1] || {};

          this.shadowAction = {
            MsgType:  shadowSwitch.MsgType,
            Values: [{
              KeyId: value0.KeyId,
              Value: Number(value0.DefaultValue),
            }, {
              KeyId: value1.KeyId,
              Value: Number(value1.DefaultValue),
            }]
          }
        }
      }

      // if (imageScene.matrix) {
      //   const matrixValue = actionList.find(item => item.Code === imageScene.matrix);

      //   if (matrixValue && matrixValue.UI) {
      //     this.matrixValueUi = matrixValue.UI;
      //   };
      // }
  
      const lightAction = actionValuesList.find(item => item.ValueType === 'UIControl_Bright');
      const temperatureAction = actionValuesList.find(item => COLOR_TEMPERATURE_VALUE_TYPES.includes(item.ValueType));
      const duvAction = actionValuesList.find(item => item.ValueType === 'UIControl_ColorTemperature_SDL_DUV');
      const duvDefault = Number(duvAction?.DefaultValue);

      return {
        optionRange: {
          light: {
            Max: lightAction ? lightAction.Max : 255,
            Min: lightAction ? lightAction.Min : 0
          },
          temperature: {
            Max: temperatureAction ? temperatureAction.Max : 255,
            Min: temperatureAction ? temperatureAction.Min : 0
          },
          duv: {
            Max: duvAction ? duvAction.Max : 8,
            Min: duvAction ? duvAction.Min : -8
          }
        },
        defaultOption: {
          light: Number(lightAction?.DefaultValue),
          temperature: Number(temperatureAction?.DefaultValue),
          duv: Number.isFinite(duvDefault) ? duvDefault : -4
        }
      }
    },
  
    async initOptionRange(device) {
      if (!device) return;

      const { optionRange, defaultOption } = await this.getOptionRange(device);

      this.optionRange = optionRange;

      this.option = {
        ...defaultOption
      }

      this.defaultOptionAche = {
        ...defaultOption
      }

      this.$refs.LightColorSet && this.$refs.LightColorSet.setOption({
        ...defaultOption
      })
    },

    requestInfo() {
      const routeOpts = mergeSceneRouteOpts(this.$route);
      const sceneNo = this.embedInRecycle
        ? this.embedSceneNo
        : routeOpts.SceneNo;
      const gpNo = this.embedInRecycle
        ? this.embedGpNo
        : routeOpts.GpNo;

      this.parameters.SceneNo = sceneNo;
      this.parameters.GpNo = gpNo;

      let para = {
        sceneNo
      };

      if (this.parameters.from === 'recycle') {
        SceneRecoverDetail(para, this.initInfo);
        return;
      }

      FindScene(para, this.initInfo);
    },

    async initInfo(res) {
      if (
        res.StatusCode == this.$store.state.rightStatusCode &&
        res.Result
      ) {
        this.parameters = {
          ...this.parameters,
          ConfigStatus: res.Result.ConfigStatus
        };
  
        let totalNum = 0;
        const deviceList = res.Result.DeviceList || [];
        this.parameters.ConfigStatus = res.Result.ConfigStatus;
        const abilityDevice = this.getValidAbilityDevice(deviceList);
        if (abilityDevice) {
          const ActionList = abilityDevice.ActionList || {};
          const Values = (ActionList[0] || {}).Values || [];
          const totalNumModal = Values.find(item => item.KeyId === 3);

          if (totalNumModal) totalNum = totalNumModal.Value;

          this.device = abilityDevice;
        }

        const Mark4Res = await GetCustomDataList({
          projectCode: this.$store.state.projectcode,
          type: 'MatrixScene',
          identifier: this.parameters.SceneNo
        });
        // const { Mark4 } = res.Result;

        const Mark4 = ((Mark4Res?.Result || [])[0] || {}).Content || res.Result.Mark4;

        // const { Mark4 } = res.Result;

        if (!!Mark4) {
          try {
            const MarkRes = JSON.parse(Mark4);
            const { initData } = MarkRes;
            const option = MarkRes.option;

            this.parameters.shapeType = MarkRes.shapType;
            this.parameters.deviceText = MarkRes.option?.deviceText || '';
            this.parameters.colRowOption = {
              col: MarkRes.option.col || 1,
              row: MarkRes.option.row || 1
            }
            this.setTemlateByShapeType(MarkRes.shapType)
            console.log('initData.renderList', initData.renderList);

            const renderList = initData.renderList.map(list => {
              // colorData: item.colorData,
              // cxcyValue: item.cxcyValue,
              // duv: item.duv,
              // hasEdit: item.hasEdit,
              // id: item.id,
              // light: item.light,
              // lightMode: item.lightMode,
              // position: item.position,
              // shadow: item.shadow,
              // switch: item.switch,
              // temperature: item.temperature,
              return list.map(
                item => (
                  {
                    ...item,
                    switch: item.switch === undefined ? true : item.switch,
                    color: `rgb(${item.colorData.r}, ${item.colorData.g}, ${item.colorData.b})`,
                    hex: rgbToHex(item.colorData.r, item.colorData.g, item.colorData.b),
                    isSelected: false,
                  }
                )
              )
            });

            setTimeout(() => {
              const splicingHoles = MarkRes.option?.splicingHoles || [];
              this.$refs.LightColorSet.initData({ 
                bg: initData.bg, 
                renderList, 
                splicingBgStyle: {
                  left: MarkRes.option?.left || 0,
                  top: MarkRes.option?.top || 0,
                  scale: MarkRes.option.scale || 1,
                },
                imageMode: MarkRes.option?.imageMode,
                isShadowOpen: MarkRes.option?.isShadowOpen,
                isNeedMirror: !!MarkRes.option?.isNeedMirror,
                splicingHoles,
              });
              // 无 Mark4 洞位时，再按系统 IsDel 兜底挖洞
              if (!splicingHoles.length) {
                this.$refs.LightColorSet && this.$refs.LightColorSet.syncHolesFromDeviceList(this.checkDeviceList);
              }
            }, 1000)
            
            const { optionRange, defaultOption } = await this.getOptionRange(
              this.getValidAbilityDevice(deviceList)
            );
            this.optionRange = optionRange;

            this.defaultOptionAche = {
              ...defaultOption
            }
            console.log('MarkRes', MarkRes, option);
            this.option = option;
            // this.stripDialogInfo.directionType = directionType;            
          } catch (e) {
            console.log('e', e);
          }
        }

        this.$refs.baseInfo && this.$refs.baseInfo.setFormData({
          SecneName: res.Result.SecneName,
          SceneType: res.Result.SceneType
        });
        
        // 删除的设备放最下面
        this.checkDeviceList = deviceList
          .filter(item => !item.IsDel)
          .concat(
            deviceList.filter(item => !!item.IsDel)
          );

        if (!this.device) {
          this.device = this.getValidAbilityDevice(this.checkDeviceList) || this.checkDeviceList[0];
        }
        if (!this.template) {
          this.setTemlateByShapeType(this.parameters.shapeType || 1);
        }
      }
    },

    // 初始化路由参数
    initRouteParams() {
      const params = mergeSceneRouteOpts(this.$route);
      console.log('initRouteParams', params);
      
      // if (!params || !params.shapeType) {
      //   this.$router.push({
      //     name: 'control'
      //   });
      // }

      this.parameters.shapeType = params.shapeType;
      this.parameters.GpNo = params.GpNo;
      this.parameters.CustomGroups = params.CustomGroups;
      this.parameters.colRowOption = params.stripOption?.colRowOption || {};
      this.parameters.deviceText = params.deviceText || '';

      this.checkDeviceList = (params.checkDeviceList || []).sort((pre, next) => {
        return (pre || {}).DeviceName - (next || {}).DeviceName;
      });
      // console.log('params.checkDeviceList', params.checkDeviceList);
      
      this.device = this.getValidAbilityDevice(this.checkDeviceList) || this.checkDeviceList[0];

      this.initOptionRange(this.device);
      this.setTemlateByShapeType(params.shapeType)
    },

    setTemlateByShapeType(shapeType) {
      switch (shapeType) {
        case 1:
          this.template = TEMPLATE_1;
          break;
        case 2:
          this.template = TEMPLATE_2;
          break;
        case 3:
          this.template = TEMPLATE_3;
          break;
        case 4:
          this.template = TEMPLATE_4;
          break;
        case 5:
           this.template = TEMPLATE_5;
           break;
        case 6:
            this.template = TEMPLATE_6;
            break;
        case 7:
            this.template = TEMPLATE_7;
            break;
        case 8:
            this.template = TEMPLATE_8;
            break;
        case 9:
            this.template =  TEMPLATE_9;
            break;
        case 10:
            this.template = TEMPLATE_10;
            break;
        case 11:
            this.template = TEMPLATE_11;
            break;
        case 12:
            this.template = TEMPLATE_12;
            break;
        case 13:
            this.template = TEMPLATE_13;
            break;
        case 14:
            this.template = TEMPLATE_14;
            break;
        case 15:
            this.template = TEMPLATE_15;
            break;
        case 16:
            this.template = TEMPLATE_16;
            break;
        case 17:
            this.template = TEMPLATE_17;
            break;
        case 18:
            this.template = TEMPLATE_18;
            break;
        case 19:
            this.template = TEMPLATE_19;
            break;
        case 20:
            this.template = TEMPLATE_20;
            break;
        case 21:
            this.template = TEMPLATE_21;
            break;
        case 22:
            this.template = TEMPLATE_22;
            break
        case 23:
            this.template = TEMPLATE_23;
            break;
        case 24:
            this.template = TEMPLATE_24;
            break;
        case 29:
            this.template = TEMPLATE_29;
            break;
        default:
          this.template = TEMPLATE_1;
  
      }
    },

    // 上移 下移 / 手动删除
    onUpdateList(newList, deletedIndex) {
      if (typeof deletedIndex === 'number' && this.$refs.LightColorSet) {
        // 仅 UI 挖洞；列表已移除设备；下发仍走原逻辑
        this.$refs.LightColorSet.addSplicingHoleByDeviceListIndex(deletedIndex);
      }
      this.checkDeviceList = newList;
      this.$forceUpdate();
      this.$nextTick(() => {
        this.$refs.LightColorSet && this.$refs.LightColorSet.ensureActiveSplicingView();
      });
    },

    handlerSaveClick() {
      if (this.parameters.from === 'edit') {
        this.reqEdit();
      } else {
        this.reqSave();
      }
    },

    onOptionChange(value) {
      this.$refs.LightColorSet && this.$refs.LightColorSet.setValue(value);
    }, 

    onResetOption() {
      this.option = {
        light: this.defaultOptionAche?.light,
        temperature: this.defaultOptionAche?.temperature,
        duv: this.defaultOptionAche?.duv
      };
    },

    // 取消按钮
    handlerBack() {
      this.$router.push({
        path: '/control'
      })
    },

    // 校验上传保存或者编辑
    verifyCanSave() {
      const baseInfo = this.$refs.baseInfo.getFormData();
      const { checkDeviceList } = this;

      if (!baseInfo.nameValue) {
        return {
          status: false,
          message: this.$t('scene.plhode1'),
        }
      };

      if (!this.getValidAbilityDevice(checkDeviceList)) {
        return {
          status: false,
          message: this.$t('sceneCard.noAvailableDevice'),
        }
      }

      if (!this.$refs.LightColorSet || !this.$refs.LightDuvControl) {
        return {
          status: false,
          message: this.$t('sceneCard.noAvailableDevice'),
        }
      }

      return {
        status: true,
      }
    },

    // 点击保存
    async reqSave() {
      const baseInfo = this.$refs.baseInfo.getFormData();
      const { checkDeviceList } = this;
      const { GpNo, CustomGroups } = this.parameters;
      const isCanSubmit = this.verifyCanSave();

      if (!isCanSubmit.status) {
        this.$message({
          type: 'warning',
          message: isCanSubmit.message
        });

        return;
      }

      try {
        this.isLoadingSave = true;

        const DeviceList = await this.handlerCheckDeviceList(checkDeviceList);

        const Mark4 = await this.getMark4();

        const reqParams = {
          GpNo,
          SecneName: baseInfo.nameValue,
          SceneType: baseInfo.selectvalue,
          DeviceList,
          CustomGroups,
          TransportType: 'MatrixScene',
          Mark4: '',
          ShowEntry: 5,
        }

        const res = await reqSaveScene(reqParams);

        await SaveOrUpdateCustomData([{
          ProjectCode: this.$store.state.projectcode,
          Type: 'MatrixScene',
          Identifier: res.Result,
          Content: Mark4
        }]);

        this.functionDoNotice(res);
      } catch (e) {
        console.log('err', e);
        
      } finally {
        this.isLoadingSave = false;
      }
    },

    // 点击保存且编辑
    async reqEdit() {
      const baseInfo = this.$refs.baseInfo.getFormData();
      const { checkDeviceList } = this;
      const { GpNo, CustomGroups, SceneNo } = this.parameters;
      const isCanSubmit = this.verifyCanSave();

      if (!isCanSubmit.status) {
        this.$message({
          type: 'warning',
          message: isCanSubmit.message
        });

        return;
      }

      const DeviceList = await this.handlerCheckDeviceList(checkDeviceList);
      const Mark4 = await this.getMark4();
  
      try {
        this.isLoadingSave = true;

        const reqParams = {
          GpNo,
          SecneName: baseInfo.nameValue,
          SceneType: baseInfo.selectvalue,
          DeviceList,
          CustomGroups,
          TransportType: 'MatrixScene',
          SceneNo: SceneNo,
          Mark4: '',
          ShowEntry: 5,
        }

        console.log('Mark4 Mark4 save', Mark4);
        
        const res = await reqEditScene(reqParams);

        await SaveOrUpdateCustomData([{
          ProjectCode: this.$store.state.projectcode,
          Type: 'MatrixScene',
          Identifier: res.Result,
          Content: Mark4
        }]);

        this.functionDoNotice(res);
      } catch (e) {
      } finally {
        this.isLoadingSave = false;
      }
    },

    /* 提交数据 接口返回处理
     * rs 接口返回数据包
     */
     functionDoNotice(rs) {
      // if (rs.StatusCode === this.$store.state.rightStatusCode) {
      if (rs.StatusCode === this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);

        this.$router.push({
          path: '/control'
        })
        // if (rs.Result) {
        //   // this.removecurrent.push({ sceneNo: rs.Result });
        //   // this.courseDialog = true;
        // } else {
        //   this.gopage();
        // }
      } else {
        alerterror(this, rs.StatusCode);
      }
    },

    getFirstDeviceId() {
      const checkDeviceList = this.checkDeviceList;

      return (checkDeviceList[0] || {}).VDeviceId;
    },

    // 滚动事件
    scrollEvent(e) {

    },

    // 处理选择的设备
    async handlerCheckDeviceList(checkDeviceList) {
      if (!this.$refs.LightColorSet) return;

      const option = this.$refs.LightDuvControl.getValue();
      const renderList = this.$refs.LightColorSet.getRenderList();
      const canvasOption = this.$refs.LightColorSet.getCanvasOption();

      return checkDeviceList.filter(item => !item.IsDel).map((device, i) => {
        const colorsData = renderList[i];
        let lightCxCyStr = '';
  
        colorsData.forEach(item => {
          if (item.lightMode === 1) {
            lightCxCyStr +=`${Math.floor(item.light).toString(16)}FF${transDuvValue(item.duv)}${transTemperature(item.temperature)}`
          }

          if (item.lightMode === 2) {
            const imageMode = canvasOption.imageMode;

            const color = item.switch ? `${item.colorData.r},${item.colorData.g},${item.colorData.b},255` : '0,0,0,255'
            const data = transformPointToCXCY({
              color,
              light: item.light,
              mode: imageMode === 1 ? 'V1' : 'V2'
            }, this.matrixValueUi);

            lightCxCyStr += data;
          }
        });

        const newActionList = {
          MsgType:  "0x13010000",
          Values: [{
            KeyId: 0, // Channel
            Value: 0,
          }, {
            KeyId: 1, // Mode
            Value: 3,
          }, {
            KeyId: 2, // StartAddr
            Value: 0,
          }, {
            KeyId: 3, // TotalNum
            Value: colorsData.length
          }, {
            KeyId: 4,
            Value: lightCxCyStr
          }],
        }

        return {
          AreaName: device.AreaName,
          ChannelId: device.ChildId,
          DeviceName: device.DeviceName,
          VDeviceId: device.VDeviceId,
          Mac: device.Mac,
          ActionList: [ newActionList ]
        }
      })
    },

    async getMark4() {
      const colorSet = this.$refs.LightColorSet;
      const duvControl = this.$refs.LightDuvControl;
      if (!colorSet || !duvControl) return '';

      const baseOption = duvControl.getValue();
      const canvasOption = colorSet.getCanvasOption();
      const stageSize = colorSet.getCanvasStageSize();
      const position = colorSet.getPosition();
      const bg = colorSet.getBg();
      const renderList = colorSet.getRenderList();

      let appBg = bg;
      try {
        if (document.getElementById('scene-splicing-view-shoot')) {
          const blob = await shootImg('scene-splicing-view-shoot');
          const formData = new FormData();
          formData.append('file', blob, 'screenshot.png');
          const res = await UploadFile(formData);
          if (res && res.StatusCode === this.$store.state.rightStatusCode) {
            appBg = res.Result.RootPath + res.Result.FilePath;
          }
        }
      } catch (e) {
        console.log('getMark4 shootImg', e);
      }

      const bgSize = {
        width: 300,
        height: 300,
      };
  
      const Mark4 = {
        shapType: this.parameters.shapeType,
        initData: {
          bg,
          renderList,
          stageSize, 
          appSize: bgSize,
          bgSize: bgSize
        },
        option: {
          ...baseOption,
          ...canvasOption,
          modeType: 2,
          calType: 1, // 1. 快速算法 2. 拖动
          deviceText: this.parameters.deviceText,
          isNeedMirror: true,
          // deviceScale: this.template.scale,
          // deviceIsGroup: this.template.isGroup,
          // shape: this.template.shape,
          // row: option.row,
          // col: option.col,
          // scale: 
        },
        appData: {
          position,
          bg: appBg,
          width: 300, 
          height: 300
        }
      };


      return JSON.stringify(Mark4);
    },

    onImgUpdate({ title }) {
      const baseInfo = this.$refs.baseInfo.getFormData();

      if (!!title && !baseInfo.nameValue) {
        this.$refs.baseInfo && this.$refs.baseInfo.setFormData({
          SecneName: title,
        });
      }
    },

    onDeviceSort(newList) {
      this.checkDeviceList = newList;
      this.$forceUpdate();
    }
  },
};
</script>

<style lang="scss" scoped>
.scene_main {
  display: flex;
  position: absolute;
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;
  height: 92%;
  background: #fefefe;

  ::v-deep .scene_title {
    display: flex;
    margin-bottom: 24px;
  }

  ::v-deep .scene_container {
    padding: 20px 45px;
    border: solid 1px #e0e3e6;
  }

  .scene_btnList {
    display: flex;
    justify-content: flex-end;
    margin-top: 48px;
  }

  .scene_save {
    background-color: #002a91 !important;
    color: #fff !important;

    &:hover {
      background-color: #002a91 !important;
      color: #fff !important;
    }
  }
}
</style>